module.exports = __webpack_public_path__ + "static/media/ci_sort-descending.46c52d46.svg";